import React from 'react';
import { IoChatbubblesOutline, IoClose } from 'react-icons/io5';

interface Props {
  isOpen: boolean;
  onClick: () => void;
  hasActivity?: boolean;
  className?: string;
}

const ChatButton: React.FC<Props> = ({ isOpen, onClick, hasActivity = false, className }) => (
  <button
    className={`bot-fab ${isOpen ? 'bot-fab--open' : ''}${className ? ` ${className}` : ''}`}
    onClick={onClick}
    aria-label="Chat"
  >
    {isOpen ? <IoClose size={26} /> : <IoChatbubblesOutline size={26} />}
    {!isOpen && hasActivity && <span className="bot-fab__badge" />}
  </button>
);

export default ChatButton;
